var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPartsWomanOff = function SvgPartsWomanOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "M16 6.095c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4m.571 12.593V15.2c2.578-.287 4.572-2.496 4.572-5.106A5.15 5.15 0 0 0 16 4.952a5.15 5.15 0 0 0-5.143 5.143c0 2.61 1.994 4.82 4.572 5.106v3.487H9.714v1.143h5.715v7.217h1.142V19.83h5.715v-1.143z",
    clipRule: "evenodd"
  })));
};
export default SvgPartsWomanOff;